import { Node } from '@tiptap/core';
import { mergeAttributes } from '@tiptap/core';
export const TargetAudience = Node.create({
    name: 'targetAudience',
    group: 'block',
    atom: true,
    draggable: true,
    addAttributes() {
        return {
            description: {
                default: '',
                renderHTML(attrs) {
                    return { 'data-description': attrs.description };
                },
                parseHTML(element) {
                    return element.getAttribute('data-description') ?? '';
                },
            },
        };
    },
    addCommands() {
        return {
            setTargetAudience: () => ({ commands }) => {
                return commands.insertContent({ type: this.name });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mb-target-audience',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mb-target-audience', mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=target-audience.js.map